var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { connect } from 'react-redux';

import { Icon as PropertyIcon } from "../../Layout";
import formatter from "../../Metadata/helpers/formater";
import { TableCell } from "./TableCell";













const getColumnValue = (
formattedEntity,
columnValues,
column) =>
{
  let columnValue;
  const columnName = column.name;
  if (!column.isCommonProperty || columnName === 'creationDate' || columnName === 'editDate') {
    columnValue = columnValues.get(columnName);
  } else {
    const commonPropValue =
    columnName === 'templateName' ? formattedEntity.documentType : formattedEntity[columnName];
    columnValue = column;
    columnValue.value = commonPropValue;
  }
  return columnValue;
};

const mapStateToProps = (state, { entity, storeKey = 'library' }) => {
  const selected =
  state[storeKey].ui.
  get('selectedDocuments').
  find(
    (doc) => (doc === null || doc === void 0 ? void 0 : doc.get('_id')) === entity.get('_id')
  ) !== undefined;
  return {
    selected,
    templates: state.templates,
    thesauris: state.thesauris,
    zoomLevel: state[storeKey].ui.get('zoomLevel')
  };
};

const connector = connect(mapStateToProps);


const TableRowComponent = ({
  clickOnDocument,
  entity,
  templates,
  thesauris,
  columns,
  selected,
  multipleSelection,
  setMultipleSelection,
  zoomLevel = 2
}) => {
  const checkEntity = (e) => {
    const { metaKey, ctrlKey, shiftKey } = e;
    clickOnDocument({ metaKey, ctrlKey, shiftKey }, entity, selected, multipleSelection);
    setMultipleSelection(true);
    e.stopPropagation();
  };

  const selectRow = (e) => {
    const { metaKey, ctrlKey, shiftKey } = e;
    const sel = window.getSelection();
    const selectionKeyPressed = e.metaKey || e.ctrlKey;

    if ((sel === null || sel === void 0 ? void 0 : sel.type) === 'Range' && !selectionKeyPressed) {
      return null;
    }
    setMultipleSelection(selectionKeyPressed);
    return clickOnDocument({ metaKey, ctrlKey, shiftKey }, entity, selected, selectionKeyPressed);
  };

  const formattedEntity = formatter.prepareMetadata(entity.toJS(), templates, thesauris, null, {
    sortedProperties: ['editDate', 'creationDate']
  });
  const columnValues = new Map();
  formattedEntity.metadata.forEach((prop) => {
    columnValues.set(prop.name, prop);
  });

  const cells = columns.map((column) => {
    const key = formattedEntity._id + column.name;
    const value = getColumnValue(formattedEntity, columnValues, column);
    return { key, value };
  });
  const [firstCell, ...rowCells] = cells;

  return /*#__PURE__*/(
    _jsx("tr", {
      className: `template-${formattedEntity.template} ${selected ? 'selected' : ''}`,
      onClick: selectRow }, void 0,

    firstCell && /*#__PURE__*/
    _jsx("td", { className: "sticky-col" }, void 0, /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "checkbox-cell", onClick: checkEntity }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "checkbox",
      onChange: () => {},
      checked: multipleSelection && selected,
      onClick: checkEntity }
    )
    ),
    formattedEntity.icon && /*#__PURE__*/
    _jsx(PropertyIcon, {
      className: "item-icon item-icon-center",
      data: formattedEntity.icon,
      size: "sm" }
    ), /*#__PURE__*/

    _jsx(TableCell, { content: firstCell.value, zoomLevel: zoomLevel })
    )
    ),

    rowCells.map(({ key, value }) => /*#__PURE__*/
    _jsx("td", {}, `column_${key}`, /*#__PURE__*/
    _jsx(TableCell, { content: value, zoomLevel: zoomLevel })
    )
    )
    ));

};

export const TableRow = connect(mapStateToProps)(TableRowComponent);